export async function delay(ms = 1000) {
  return await new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}
